import { NgModule } from '@angular/core';
import { ChartJsModule } from '~app/components/chart-js/chart-js.module';
import { InfluxService } from './influx.service';
import { InfluxGraphComponent } from './influx-graph/influx-graph.component';
import { NgbPopoverModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedProviderModule } from '~app/shared/shared.module';
import { DateRangePickerModule } from '~app/components/date-range-picker/date-range-picker.module';
import { FontAwesomeIconsModule } from '~app/fontawesome-icons.module';
import { InfluxMetadataMisonetService } from './influx-metadata/influx-metadata-misonet.service';

@NgModule({
  imports: [
    SharedProviderModule,
    ChartJsModule,
    NgbTypeaheadModule,
    NgbTooltipModule,
    NgbPopoverModule,
    DateRangePickerModule,
    FontAwesomeIconsModule,
  ],
  declarations: [InfluxGraphComponent],
  exports: [InfluxGraphComponent],
  providers: [InfluxService, InfluxMetadataMisonetService]
})
export class InfluxModule {
}
